module.exports = __webpack_public_path__ + "img/sportshub.bc55dba0.png";